export const RunningSvg = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style>
      {`
        .bar1 { animation: bar1-bounce 1s infinite; }
        .bar2 { animation: bar2-bounce 1s infinite 0.2s; }
        .bar3 { animation: bar3-bounce 1s infinite 0.4s; }
        .bar4 { animation: bar4-bounce 1s infinite 0.6s; }
        @keyframes bar1-bounce {
          0%, 100% { y: 2; height: 12; }
          50% { y: 6; height: 4; }
        }
        @keyframes bar2-bounce {
          0%, 100% { y: 5; height: 6; }
          50% { y: 2; height: 12; }
        }
        @keyframes bar3-bounce {
          0%, 100% { y: 5; height: 6; }
          50% { y: 2; height: 12; }
        }
        @keyframes bar4-bounce {
          0%, 100% { y: 5; height: 6; }
          50% { y: 10; height: 2; }
        }
      `}
    </style>
    <rect className="bar1" x="5.5" y="2" width="2" height="12" rx="1" fill="#5964F3" />
    <rect className="bar2" x="2.5" y="5" width="2" height="6" rx="1" fill="#5964F3" />
    <rect className="bar3" x="8.5" y="5" width="2" height="6" rx="1" fill="#5964F3" />
    <rect className="bar4" x="11.5" y="5" width="2" height="6" rx="1" fill="#5964F3" />
  </svg>
)
